
import Immutable from './editor/client/Other/Immutable';
import {
  DraftInterface
} from './editor/client/Interfaces/Draft/DraftInterface';
import { calculateDaysFromStartDate } from './editor/client/Other/functions/dateFunctions';
import { ObjectNumber } from './editor/client/Other/ObjectNumber';
import { Type } from './editor/client/Other/Type';
import { calculateValuesForDraft, calculateValuesForLine } from './editor/client/Other/functions/invoiceLineFunctions';
import * as moment from 'moment';

export const initialState = { draft: {} };

export const reducer = (state, action) => {
  switch (action.type) {
    case 'INIT_DRAFT':
      return { draft: { documentType: 'Invoice' } };
    case 'CHANGE_LINES':
      return { ...state, draft: changeLines(state.draft, action) };
    case 'CHANGE_FIELDS':
      return changeFields(state, { ...state.draft, fields: action.payload });
    case 'CHANGE_DRAFT':
      return changeDraft(state, action.payload);
    default:
      throw new Error();
  }
};

const actionCreator = (type, fn?) => {
  return (dispatch, ...payload) => {
    if (fn) {
      let actionResult = fn(payload);
      if (typeof actionResult === 'function') {
        actionResult = actionResult(dispatch);
      }
      return dispatch({ type, payload: actionResult });
    } else {
      return dispatch({ type, payload: payload[0] });
    }
  };
};

// UTILITY FNS

function _clearTaxFromRows(draft: DraftInterface) {
  draft.lines.forEach((line) => {
    if (line.type && line.type === 'row') {
      line.vatPct = 0;
      line.taxTotal = 0;
      line.grossTotal = line.netTotal;
    }
  });
}

// REDUCERS

const changeDraft = (state, payload: DraftInterface) => {
  const newState = Immutable.copy(state);
  newState.draft.isDirty = true;
  newState.draft = payload;
  return newState;
};

const changeLines = (draft, { payload }) => {
  const newState = Immutable.copy(draft);
  newState.isDirty = true;
  let currentSubtotal = new ObjectNumber();
  let currentSubvat = new ObjectNumber();
  let currentSubnet = new ObjectNumber();
  const fields = newState.fields;
  payload.map((line) => {
    if (line.type === 'row') {
      calculateValuesForLine(line, fields, newState.document);
      currentSubtotal.add(line.grossTotal);
      currentSubvat.add(line.taxTotal);
      currentSubnet.add(line.netTotal);
      line.currency = fields.currency.value;
    }

    if (Type.isInvoiceSubtotalLine(line)) {
      line.grossTotal = currentSubtotal.toNumber();
      line.taxTotal = currentSubvat.toNumber();
      line.netTotal = currentSubnet.toNumber();

      currentSubvat = new ObjectNumber();
      currentSubtotal = new ObjectNumber();
      currentSubnet = new ObjectNumber();
    }
    return line;
  });
  newState.lines = payload;

  return calculateValuesForDraft(newState);

};

const changeFields = (state, payload: DraftInterface) => {
  const newState = Immutable.copy(state);
  // mark draft unsaved (dirty)
  newState.isDirty = true;
  payload.fields.columns.value = payload.fields.columns.value.map((col) => {
    return col === 'grossTotal' ? 'total' : col;
  });
  if (payload.fields.columns.value.indexOf('vatPct') < 0 && newState.lines && newState.lines.length > 0) {
    _clearTaxFromRows(newState);
  }
  if (payload.fields && payload.fields.issueDate && payload.fields.issueDate.value) {
    const now = moment(payload.fields.issueDate.value);
    const due = calculateDaysFromStartDate(now, payload.fields.paymentTime.value);
    payload.fields.dueDate.value = due.format();
  }

  newState.draft.fields = payload.fields;

  newState.draft.lines.forEach((line) => {
    if (line.type === 'subtotal' && payload.fields.columns && payload.fields.columns.value) {
      line.showTaxTotal = payload.fields.columns.value.indexOf('taxTotal') >= 0;
      line.showNetTotal = payload.fields.columns.value.indexOf('netTotal') >= 0;
      line.showGrossTotal = payload.fields.columns.value.indexOf('grossTotal') >= 0;
    }
    return line;
  });

  newState.draft = calculateValuesForDraft(newState.draft);

  return newState;
};

export const reduxActions = (dispatch) => {
  return {
    initDraft: () => actionCreator('INIT_DRAFT')(dispatch),
    changeDraft: (payload) => actionCreator('CHANGE_DRAFT')(dispatch, payload),
    changeLines: (payload) => actionCreator('CHANGE_LINES')(dispatch, payload),
    changeFields: (payload) => actionCreator('CHANGE_FIELDS')(dispatch, payload)
  };
};
